import { atom } from "jotai";

import { DataPoolItem } from "~/utils/Types";

const initialValue = [] as DataPoolItem[];

export const dataPoolAtom = atom<DataPoolItem[]>(initialValue);
